import { createFileRoute } from "@tanstack/react-router";
import { WorkflowsPage } from "@/components/schema/WorkflowsPage";

/** Administration: all workflows. */
export const Route = createFileRoute("/_app/admin/workflows/")({ component: WorkflowsPage });
